import { Form, FormRenderProps } from 'react-final-form';
import { Stack, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { TextField } from '@occc-app/design-system';
import { makeZodValidate as makeValidate } from '@occc/ui-forms';
import { Button } from '@occc/ui-design-system';

import { CREATE_OFFER_DIALOG_TITLE, CREATE_OFFER_NAME_LABEL } from '../../../tobacco-api-offers.constants';
import { createOfferNameSchema } from './create-offer-name-form.schema';

export type CreateOfferFormValues = {
  offerName: string;
};

type CreateOfferDialogProps = {
  initialName: string;
  onClose: () => void;
  onSubmit: (offerName: string) => void;
};

const validate = makeValidate(createOfferNameSchema);

export const CreateOfferDialog = ({ initialName, onClose, onSubmit }: CreateOfferDialogProps) => {
  const renderForm = ({ handleSubmit, invalid }: FormRenderProps<CreateOfferFormValues>) => (
    <form onSubmit={handleSubmit}>
      <DialogTitle>{CREATE_OFFER_DIALOG_TITLE}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} mt={2}>
          <TextField
            name={'offerName' satisfies keyof CreateOfferFormValues}
            label={CREATE_OFFER_NAME_LABEL}
            margin='none'
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='text' size='medium' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='contained' type='submit' disabled={invalid}>
          Create
        </Button>
      </DialogActions>
    </form>
  );

  return (
    <Dialog open onClose={onClose} maxWidth='xs' fullWidth onClick={(e) => e.stopPropagation()}>
      <Form<CreateOfferFormValues>
        onSubmit={({ offerName }) => onSubmit(offerName.trim())}
        render={renderForm}
        validate={validate}
        initialValues={{ offerName: initialName }}
      />
    </Dialog>
  );
};
